export const siteContent = {
  company: {
    name: "ULOOK",
    tagline: "",
    description: "We unlock the hidden spectrum with advanced space-based RF detection and geolocation. Our satellites capture faint emissions from AIS spoofing, maritime radar, satcom, and satphones, turning them into precise, real-time intelligence. Previously undetectable signals are now mapped, tracked, and understood.",
  },

  contact: {
    email: "info@ulook.space"
  },

  navigation: {
    technology: "Technology",
    solutions: "Solutions",
    careers: "Careers",
    contact: "Contact"
  },

  hero: {
    title: "Space-based RF Intelligence",
    description: [
    "Our satellites capture faint emissions from AIS spoofing, maritime radar, satcom, and satphones, and transform them into precise, real-time intelligence. By mapping the hidden spectrum from orbit, we reveal patterns of activity once lost in noise.",
    "The invisible becomes known. The unknown becomes actionable."],
    buttons: {
      primary: "Check out our solutions"
    },
    // already merged earlier: sentence-style callouts for hero (kept as-is if present)
    callouts: [
      { icon: "eye",       prefix: "Designed to reveal", highlight: "10K+",  suffix: "signals" },
      { icon: "clock",     prefix: "Autonomous Satellites for ", highlight: "24/7",  suffix: "persistent global watch" },
      { icon: "crosshair", prefix: "Engineered for sub-km accuracy",highlight: "99.9%", suffix: "precision" }
    ]
  },

  technology: {
    title: "Autonomous RF Signal Intelligence Stack",
    description:
      "Detect, classify, and geolocate signals at machine speed, Anywhere on Earth.",
    features: [
      { number: "01", title: "Signal Acquisition",    description: "Satellites sense faint RF activity across the spectrum, turning noise into awareness." },
      { number: "02", title: "Processing & Analysis", description: "Edge-AI interprets emissions in real time, revealing intent and behavior."},
      { number: "03", title: "Geolocation",           description: "Triangulates every source with precision accuracy for actionable insight." }
    ],
  },

  solutions: {
    title: "Clarity Across Domains",
    description: [
      "Scalable RF intelligence for governments, enterprises, and environmental networks.",
      "One architecture serving many missions."
    ],

    // NEW: replace feature lists with real images stored under public/images/solutions
    categories: [
      {
        title: "Government & Defense",
        description: "Integrated signal intelligence for mission planning, threat detection, and strategic awareness.",
        images: [
          "/images/solutions/government-defense.jpg"
        ]
      },
      {
        title: "Commercial Operators",
        description: "Track fleets, safeguard trade routes, and secure global logistics chains.",
        images: [
          "/images/solutions/commercial-operators.jpg"
        ]
      },
      {
        title: "Environmental Protection",
        description: "Expose illegal fishing and protect critical habitats with orbital surveillance.",
        images: [
          "/images/solutions/environmental-protection.jpg"
        ]
      },
      {
        title: "Disaster Response",
        description: "Locate distress signals, reconnect responders, and restore communication lifelines.",
        images: [
          "/images/solutions/disaster-response.jpg"
        ]
      },
    ]
  },

  cta: {
    title: "Ready to Unlock RF Intelligence?",
    description:
      "Join the future of space-based RF GEOINTELLIGENCE. Contact us to learn how ULOOK can bring clarity to your operations across defense, commercial, and humanitarian domains.",
    buttons: { primary: "Contact Us" }
  },

  footer: {
    description: "Advanced space-based RF signal detection and intelligence solutions.",
    copyright: "2025 Ulook Technolgies Pvt. Ltd. All rights reserved.",
    links: {
      company: [
        { text: "Contact Us", href: "#contact" },
        { text: "Press Kit", href: "https://drive.google.com/drive/folders/1GjnEBK6GeCfQJnVBco_ZIrBzRYsUaVWa?usp=sharing" }
      ]
    },
    contactInfo: {
      email: "info@ulook.space",
      phone: "+918123854898",
      address: [
        "#702, Second Floor, #8 MCHS Layout,",
        "K.V.Jayram Road",
        "Bengaluru, Karnataka 560064",
      ],
      companyDetails: [
        "CIN: U26515KA2024PTC191780",
        "GST: 29AADCU6401H1ZC"
      ]
    },
    annualReturns: {
      text: "Annual Returns",
      href: "https://forms.gle/scP3v4RcYxpd3a3u9"
    },
    grievance: {
      subtitle: "Any grievances can be adressed to the contact details given below.",
      email: "grievance@ulook.space",
      address: [
        "#702, Second Floor, #8 MCHS Layout,",
        "K.V.Jayram Road",
        "Bengaluru, Karnataka 560064"
      ]
    }
  }
};
